import React from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import Slider, { SeeAllSlide } from '@wix/da-shared-react/pkg/Slider';
import DuperbrowseContext from '../../../contexts/DuperbrowseContext';

import s from './StripExhibitionist.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  deviations: PapiDeviation[];
  seeAllUrl?: string;
  hasMore?: boolean;
  profileOwnerUser: PapiUser;
}

class StripExhibitionist extends React.Component<Props> {
  render() {
    return (
      <Slider className={s['slider']} scrollBy={0.5}>
        {this.renderSlides()}
      </Slider>
    );
  }

  renderSlides() {
    const {
      seeAllUrl,
      hasMore,
      deviations,
      profileOwnerUser,
      streamId,
    } = this.props;

    return (
      <DuperbrowseContext
        streamId={streamId}
        deviations={deviations}
        parent={{ title: profileOwnerUser.username }}
      >
        {deviations.map(deviation => (
          <StandardThumb
            key={deviation.deviationId}
            className={s['slider-item']}
            deviation={deviation}
            height={240}
            responsive={false}
          />
        ))}
        {hasMore && seeAllUrl && <SeeAllSlide seeAllUrl={seeAllUrl} />}
      </DuperbrowseContext>
    );
  }
}

export default StripExhibitionist;
